import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlockSortDescending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlockSortDescending"><Path d="M11 3H3V11H11V3Z" fill="currentColor"/><Path d="M22.707 13.707L21.293 12.293L19 14.5859V6H17V14.5859L14.707 12.293L13.293 13.707L18 18.4141L22.707 13.707Z" fill="currentColor"/><Path d="M11 13H3V21H11V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlockSortDescending;
